module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-collapse"
  }, [_c('b-btn', {
    class: {
      expanded: _vm.expanded
    },
    attrs: {
      "variant": "link",
      "size": "lg"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.faq.question)
    },
    on: {
      "click": _vm.toggle
    }
  }), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": _vm.collapseId,
      "aria-expanded": _vm.expanded
    }
  }, [_c('b-card', {
    domProps: {
      "innerHTML": _vm._s(_vm.faq.answer)
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e9d9480","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Faq/FaqCollapse.vue
// module id = 346
// module chunks = 1